import { FC } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { PaymentPage } from 'Pages';

import { usePaymentGenerateLinkMutation, usePaymentInfoQuery } from 'Pages/Payment/api';
import { GenerateLinkForPayment } from 'Pages/Payment/Payment.entity';
import { isSuccess } from 'utils/responseStatus';
import { getResponseError, getResponseTraceId } from '../../utils/getResponseError';

export const validateMonth = (month: string): string | undefined => {
  const m = Number(month);
  if (!month || Number.isNaN(m)) return 'Месяц не указан или не является числом';
  if (m < 1 || m > 12) return 'Месяц должен быть от 1 до 12';
  return undefined;
};

export const validateYear = (year: string): string | undefined => {
  const y = Number(year);
  if (!year || Number.isNaN(y)) return 'Год не указан или не является числом';
  if (y < 2000 || y > 2100) return 'Некорректный год';
  return undefined;
};

export const PaymentScreen: FC = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const month = searchParams.get('month') || '';
  const year = searchParams.get('year') || '';
  const sum = searchParams.get('sum') || '';
  const email = searchParams.get('email') || '';

  const paramsError = [validateMonth(month), validateYear(year)].filter(Boolean).join(', ');
  const isParamsValid = !paramsError;

  const {
    data: paymentInfo,
    isLoading: isLoadingInfo,
    isError: isInfoError,
    error: infoError,
    refetch,
  } = usePaymentInfoQuery(
    { month, year, sum, accountId: id },
    { skip: !isParamsValid },
  );
  const [paymentGenerateLink,
    { isLoading: isLoadingPayment,
      isError: isPaymentError,
      error: paymentError,
    }] = usePaymentGenerateLinkMutation();

  const handleSubmitPayment = (values: { email?: string }) => {
    if (!paymentInfo?.paymentSystems[0] || !id) return;

    const currentData: GenerateLinkForPayment = {
      email: values.email || '',
      paymentId: paymentInfo?.paymentSystems[0].paymentId,
      paymentSystemId: paymentInfo?.paymentSystems[0].paymentSystemId,
      toPaySum: paymentInfo?.paymentSystems[0].toPaySum,
      commissionSum: paymentInfo?.paymentSystems[0].commissionSum,
      sum: paymentInfo?.paymentSystems[0].sum,
    };

    paymentGenerateLink(currentData).then((data) => {
      if (isSuccess(data)) {
        data.data && document.location.replace(data.data);
      }
    });
  };

  return (
    <PaymentPage
      isAcquiringForbidden={Boolean(paymentInfo?.isAcquiringForbidden)}
      paymentInfo={paymentInfo?.paymentSystems[0]}
      status="error"
      onSubmit={handleSubmitPayment}
      isLoadingInfo={isLoadingInfo}
      isLoadingPayment={isLoadingPayment}
      isParamsValid={isParamsValid}
      isInfoError={isInfoError}
      isPaymentError={isPaymentError}
      paramsError={paramsError}
      infoError={getResponseError(infoError)}
      paymentError={getResponseError(paymentError)}
      infoTraceId={getResponseTraceId(infoError)}
      paymentTraceId={getResponseTraceId(paymentError)}
      email={email}
      onClickRetry={refetch}
    />
  );
};
